import Bowser from 'bowser'

function convert(date: Date, format: string) {
    let args = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        "S": date.getMilliseconds()
    }
    if (/(y+)/.test(format))
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let i in args) {
        let n = args[i];
        if (new RegExp("(" + i + ")").test(format))
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? n : ("00" + n).substr(("" + n).length));
    }
    return format;
};

function getDate(index: number) {
    let date = new Date(); //当前日期
    let newDate = new Date();
    newDate.setDate(date.getDate() + index);//官方文档上虽然说setDate参数是1-31,其实是可以设置负数的
    let time = convert(newDate, 'yy-MM-dd')
    return time;
}

interface FunctionItem {
    functionId: string;
    url?: string | null;
    subFunctionItems?: FunctionItem[] | null;
}

function findAncestors(data: FunctionItem[], targetId: string): string[] {
    const ancestors: string[] = [];

    // 辅助函数：在当前层级找到目标节点的父节点
    function findParent(currentLevel: FunctionItem[], childId: string): string | null {
        for (const item of currentLevel) {
            if (item?.subFunctionItems) {
                // 如果当前节点的子节点中有目标节点，返回当前节点的 functionId
                if (item?.subFunctionItems?.some(subItem => subItem?.functionId === childId)) {
                    return item?.functionId;
                }
            }
        }
        return null; // 当前层级未找到
    }

    let currentTargetId = targetId;

    while (true) {
        const parentId = findParent(data, currentTargetId);
        if (!parentId) break; // 找不到父节点时停止
        ancestors.push(parentId); // 添加父节点到结果中
        currentTargetId = parentId; // 更新当前目标为父节点，继续向上查找
    }

    return ancestors.reverse(); // 返回从顶级到直接父节点的顺序
}

export function findFunctionIdByUrl(data: FunctionItem[], targetUrl: string): string | null {
    // Helper function: 深度优先搜索找到匹配的 URL
    function dfs(items: FunctionItem[]): string | null {
        for (const item of items) {
            if (item?.url === targetUrl) {
                return item?.functionId; // 找到匹配的 URL，返回 functionId
            }
            if (item?.subFunctionItems) {
                const result = dfs(item?.subFunctionItems);
                if (result) return result; // 如果在子节点中找到，返回 functionId
            }
        }
        return null; // 没有匹配的 URL
    }

    return dfs(data);
}

function findSubFunctionItem(menuData, targetUrl) {
    for (const item of menuData) {
        // 如果有子功能项，检查子功能项是否包含目标路径
        if (item?.subFunctionItems) {
            for (const subItem of item?.subFunctionItems) {
                if (subItem?.url && subItem?.url.includes(targetUrl)) {
                    // 返回第一个子功能项的 url 和 functionId
                    return {
                        url: item?.subFunctionItems?.[0]?.url,
                        functionId: item?.subFunctionItems?.[0]?.functionId,
                    };
                }
            }
        }
    }

    // 如果没有在子功能项中找到，检查顶层菜单
    for (const item of menuData) {
        if (item?.url && item?.url?.includes(targetUrl)) {
            return {url: item?.url, functionId: item?.functionId};
        }
    }

    // 如果未找到匹配项
    return {};
}


export const isInIpadFn = (): boolean => {
    const userAgent = navigator.userAgent
    const browser = Bowser.getParser(userAgent)
    const browserName = browser.getBrowserName()
    const platformObj = browser.getPlatform()
    if (browserName === 'Safari' && navigator.maxTouchPoints > 0) {
        return true
    }
    if ((platformObj?.model ?? '') === 'iPad') {
        return true
    }
    return false
}

const isInIpad = isInIpadFn()

export const isInBxWebviewFn = (): boolean => {
    const userAgent = navigator.userAgent
    const regex = /ua_iboxiao/i
    return regex.test(userAgent)
}

const isInBxApp = isInBxWebviewFn()

const isInPad = isInIpad || isInBxApp


const findUrlInMenu = (functionItems: FunctionItem[], targetUrl: string): boolean => {
    for (let item of functionItems) {
        // 检查当前项的url是否匹配
        if (item.url === targetUrl) {
            return true;
        }
        // 如果有子菜单，递归检查子菜单
        if (item.subFunctionItems && item.subFunctionItems.length > 0) {
            if (findUrlInMenu(item.subFunctionItems, targetUrl)) {
                return true;
            }
        }
    }
    return false;
};


export {convert, getDate, findAncestors, findSubFunctionItem, isInPad, isInBxApp, isInIpad, findUrlInMenu}
